import { useCSVReader } from 'react-papaparse';
import { useSetRecoilState } from 'recoil';

import { UploadCsvStateCaptable } from '../../states';

export const CSVReader = () => {
	const { CSVReader } = useCSVReader();
	const setUploadCsv = useSetRecoilState(UploadCsvStateCaptable);

	return (
		<CSVReader
			onUploadAccepted={(results: { data: any[][] }) => {
				const luckyCaptableInfo: any = window;
				luckyCaptableInfo?.luckysheet?.exitEditMode();

				// Clear all existing rows except header (start from row index 1)
				luckyCaptableInfo?.luckysheet
					.getSheetData()
					?.forEach((row: any[], i: number) => {
						if (i >= 1 && i < 50) {
							row?.forEach((_: any, j: number) => {
								if (j < 50) {
									luckyCaptableInfo.luckysheet.setCellValue(i, j, '');
								}
							});
						}
					});

				// Insert CSV data row-wise, skipping the header row (rowIndex === 0)
				results?.data?.forEach((row: any[], rowIndex: number) => {
					if (rowIndex === 0) return;

					row.forEach((cell: any, colIndex: number) => {
						luckyCaptableInfo?.luckysheet?.setCellValue(
							rowIndex,
							colIndex,
							cell
						);
					});
				});
				setUploadCsv(false);
				setTimeout(() => {
					setUploadCsv(true);
				}, 5000);
			}}
		>
			{({ getRootProps }: any) => (
				<>
					<div {...getRootProps()}>
						<div className="UploadCSVInput--addBtn">
							<label htmlFor="browse-file">Import csv</label>
						</div>
					</div>
				</>
			)}
		</CSVReader>
	);
};
